import { render, staticRenderFns } from "./Generic.vue?vue&type=template&id=873e13e8&scoped=true&"
import script from "./Generic.vue?vue&type=script&lang=js&"
export * from "./Generic.vue?vue&type=script&lang=js&"
import style0 from "./Generic.vue?vue&type=style&index=0&id=873e13e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "873e13e8",
  null
  
)

export default component.exports